export * from "-!../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./BuzonPage.vue?vue&type=template&id=ec22e31c&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/pages/BuzonPage.vue?vue&type=template&id=ec22e31c&scoped=true&
// module id = 551
// module chunks = 30